import {AuditTriggerLogs} from '@drl/shared/models/audit-trigger-logs.model';

export class PrescriptionAuditLog extends AuditTriggerLogs {
  actorInitials?: string;
  showLog: boolean;
  photoUrl?: string;
  actions: {actionText: string; actionField: string}[];
}
